import React from 'react';

const AccessDenied = ({ message }) => {
  return (
    <div className="access-denied">
      <div className="access-denied-content">
        <div className="access-denied-icon">🔒</div>
        <h2>Acesso Restrito</h2>
        <p>{message || 'Você não tem permissão para acessar esta página.'}</p>
        <p className="access-denied-instruction">
          Entre em contato com o administrador do sistema para solicitar acesso.
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;